import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { signIn } = useAuth();

  const handleLogin = async () => {
    setLoading(true);
    setError("");
    
    const { data, error: authError } = await signIn(email, password);
    
    setLoading(false);
    
    if (authError) {
      setError(authError.message);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="themed-background" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px'
    }}>
      {/* Main Login Form */}
      <div className="form-container themed-surface" style={{
        borderRadius: '12px',
        boxShadow: '0 4px 6px var(--shadow-color)',
        border: '1px solid var(--border-color)'
      }}>
        <h2 style={{
          textAlign: 'center',
          marginBottom: '30px',
          color: 'var(--color-surface-text)',
          fontSize: '24px',
          fontWeight: '600'
        }}>
          Welcome Back
        </h2>

        {error && (
          <div style={{
            color: '#dc3545',
            marginBottom: '15px',
            padding: '10px',
            backgroundColor: '#f8d7da',
            border: '1px solid #f5c6cb',
            borderRadius: '6px',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        <form data-testid="login-form" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div>
            <label htmlFor="email" style={{
              display: 'block',
              marginBottom: '8px',
              color: 'var(--color-surface-text)',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              Email Address
            </label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-input"
            />
          </div>

          <div>
            <label htmlFor="password" style={{
              display: 'block',
              marginBottom: '8px',
              color: 'var(--color-surface-text)',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              Password
            </label>
            <input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
            />
          </div>

          {/* Better positioned and styled buttons */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            marginTop: '10px'
          }}>
            <button
              type="button"
              onClick={handleLogin}
              disabled={loading}
              className="form-button"
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>

            <button
              type="button"
              onClick={() => navigate("/signup")}
              style={{
                width: '100%',
                padding: '12px 20px',
                borderRadius: '8px',
                border: '2px solid var(--color-primary)',
                backgroundColor: 'transparent',
                color: 'var(--color-primary)',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                outline: 'none'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = 'var(--color-primary)';
                e.target.style.color = 'var(--color-primary-text)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--color-primary)';
              }}
            >
              Create Account
            </button>
          </div>
        </form>

        <div style={{
          textAlign: 'center',
          marginTop: '20px',
          color: 'var(--color-outline)',
          fontSize: '14px'
        }}>
          New to the platform? Start learning today!
        </div>
      </div>
    </div>
  );
}

export default Login;
